import { defineComponent as _defineComponent } from 'vue'

import Icon from "@/components/widgets/icons/Icon.vue"
import Pulse from "@/components/widgets/Pulse/Pulse.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'CalloutCard',
  props: {
    callToAction: null,
    title: null,
    subtitle: null,
    btnLabel: null
  },
  emits: ["click"],
  setup(__props: any) {





return { __sfc: true,Icon, Pulse }
}

})